import {Component, DestroyRef, Input, OnInit} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  LicenseApplicationModel,
  LicenseCenterModel,
  LicenseCompanyModel,
  LicenseModel
} from "../../../models/license.model";
import {LicenseService} from "../../../services/licenses-service/license.service";
import {ActivatedRoute} from "@angular/router";
import {tap} from "rxjs/operators";
import {CompanyModel} from "../../../models/company.model";

@Component({
    selector: 'app-licenses-license-dashboard',
    templateUrl: './licenses-license-dashboard.component.html',
    styleUrls: ['./licenses-license-dashboard.component.scss'],
    standalone: false
})
export class LicensesLicenseDashboardComponent implements OnInit {

  license: LicenseModel;
  centers: LicenseCenterModel[];
  applications: LicenseApplicationModel[];

  constructor(private activatedRoute: ActivatedRoute,
              private licenseService: LicenseService,
              private destroyRef: DestroyRef) { }

  ngOnInit() {
    this.listenRefreshLicense();
    this.getLicense()
  }

  private getLicense() {
    const licenseId = this.activatedRoute.snapshot.params['licenseId'];
    this.licenseService.getLicense(licenseId).pipe(
      takeUntilDestroyed(this.destroyRef),
      tap((res: LicenseModel) => this.license = res),
      tap((res: LicenseModel) => this.getCenters(this.license.companyInternalId)),
      tap((res: LicenseModel) => this.getApplications(this.license.companyInternalId))
    ).subscribe();
  }

  public getCenters(internalId: string) {
    this.licenseService.getCenters(internalId).pipe(
      takeUntilDestroyed(this.destroyRef),
      tap((res: LicenseCenterModel[]) => this.centers = res)
    ).subscribe();
  }

  public getApplications(internalId: string) {
    this.licenseService.getApplications(internalId).pipe(
      takeUntilDestroyed(this.destroyRef),
      tap((res: LicenseApplicationModel[]) => this.applications = res)
    ).subscribe();
  }

  private listenRefreshLicense() {
    this.licenseService.listenRefreshLicense().pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(
      (res) => {
        this.getLicense();
      }
    );
  }

}
